import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import _ from 'lodash'

import PipelineCard from 'components/PipelineCard'
import { selectPipeline } from 'store/selectors/pipeline'

const PipelineCardContainer = ({ opportunity, stageId, index, onDrop }) => {
  const { results: pipelineData } = useSelector(selectPipeline)

  const [isDraggedOver, setIsDraggedOver] = useState(false)

  const ref = useRef(null)

  useEffect(() => {
    return dropTargetForElements({
      element: ref.current,
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      onDrop: ({ source }) => {
        setIsDraggedOver(false)
        onDrop({ destination: { droppableId: stageId, index }, draggableId: source.data.id })
      }
    })
  }, [pipelineData, stageId, index])

  return (
    <div ref={ref} className={`Pipeline__card-container ${isDraggedOver ? 'active' : ''}`}>
      {opportunity && <PipelineCard opportunity={opportunity} />}
    </div>
  )
}

const PipelineStage = ({ id: stageId, name, opportunities, onDrop }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const fundersCount = opportunities.length
  const fundersPlural = fundersCount !== 1

  return (
    <>
      <h4>{name}</h4>
      <small>{`${fundersCount} ${
        fundersPlural ? t.pipeline.prospectiveFunders : t.pipeline.prospectiveFunder
      }`}</small>
      <div className={`Pipeline__column ${name}`}>
        {opportunities
          .sort((a, b) => a.pipelineStageOrder - b.pipelineStageOrder)
          .map((opportunity, index) => {
            return (
              <PipelineCardContainer
                key={opportunity.id}
                opportunity={opportunity}
                index={index}
                stageId={stageId}
                onDrop={onDrop}
              />
            )
          })}
      </div>
    </>
  )
}

export default PipelineStage
